export default __webpack_public_path__ + "static/media/AutoJoinList.3ed76b11.svg";